import { TimePickerBase, TimePickerBaseProps } from "@compass/core";
import { ModelPropertyBase } from "generated/openApi";

export const TimePicker = (
  props: TimePickerBaseProps & {
    modelProperty?: ModelPropertyBase | undefined;
  }
) => {
  const { modelProperty, ...rest } = props;
  return <TimePickerBase label={modelProperty?.displayName} required={modelProperty?.required} {...rest} />;
};
